import type { TreasuryPlan } from "../domain/treasury";

/** REVIEW DATA ONLY. Never publish this catalogue or these prices as live terms. */
export const TREASURY_PREVIEW = {
  version: 1,
  storageKey: "diamond-kingdom:treasury-preview:v1",
  rewardMicros: "100000000",
  grimNano: "20000000000000",
  grimPriceMicros: "25000",
  gramPriceMicros: "3000000",
  networkBudgetNano: "120000000",
  quoteLifetimeMs: 90_000,
  confirmationMs: 2200,
  plans: [20, 50, 100].map(value => ({ id: `preview-${value}`, nominalMicros: String(value * 1_000_000),
    durationSeconds: 30 * 86400, initialBps: 1000, mentorBps: 1000, protocolBps: 1000, available: true })) satisfies TreasuryPlan[],
} as const;
